<template>
  <section class="appendix">
    <section class="appendix-news" v-if="list">
      <div class="product-description">
        <h2 class=" half">{{title}}</h2>
      </div>

      <section class="card-column-list">
        <card-case-small v-for="(item) in list" :key="item.id"
                         :title="item.title"
                         :date="item.date"
                         :image="item.image"
                         :id="item.id"
                         :link="url + item.id"
                         :text="item.text"
        ><span v-html="item.text"></span>
        </card-case-small>
      </section>

    </section>
  </section>
</template>

<script>
  import CardCaseSmall from "../shared/cards/CardCaseSmall"

  export default {
    props: {
      list: { type: Array },
      title: { type: String, default: 'Другие проекты Russ Outdoor' },
      url: { type: String },
    },
    data() {
      return {
        entities: this.list,
      };
    },
    watch: {
      list(newValue) {
        this.entities = newValue;
      },
    },
    components: {
      CardCaseSmall
    },
  }
</script>

<style lang="scss" scoped>
  .appendix {
    //border-top: 4px solid $color-text;
    padding: 0px 0 0;

    @media (max-width: 600px) {
     // padding: 50px 0px;
    }
    .card-column-list {
      padding: 25px 0 75px;
    }
    @media (max-width: $media_xs) {
        padding-bottom: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// components/articles/ArticleRelated.vue